import { BADGES } from '@/data/badges'
import { usePlayer } from '@/hooks/player/usePlayer'
import { useToast } from '@/providers/ToastProvider'
import { useEffect, useRef } from 'react'

export function useBadgeToast() {
  const { player } = usePlayer()
  const { showToast } = useToast()
  const prevBadgesRef = useRef<string[] | null>(null)

  useEffect(() => {
    if (!player) return
    const currentBadges = player.badges
    const prevBadges = prevBadgesRef.current
    prevBadgesRef.current = currentBadges

    // Skip on first observation — don't toast for existing badges
    if (prevBadges === null) return

    const newBadges = currentBadges.filter((b) => !prevBadges.includes(b))

    for (const badgeId of newBadges) {
      const badge = BADGES[badgeId as keyof typeof BADGES]
      if (badge) {
        showToast(`${badge.name}: ${badge.description}`, {
          variant: 'badge',
          duration: 4000,
        })
      }
    }
  }, [player?.badges, showToast, player])
}
